import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid #707374;
  border-radius: 6px;
  padding: 13px;
  .timeValidationMessage {
    font-size: 13px;
    color: red;
    margin-bottom: 20px;
  }
  .action-zone-audio-wrapper {
    position: relative;
    input {
      background: var(--input-background);
      border-radius: 6px;
      height: 30px;
      width: 100%;
      color: var(--text-primary);
      padding: 0 36px 0 16px;
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 6px;
    }
    button {
      padding: 0;
      position: absolute;
      right: 0;
      background: transparent;
      border: 1px solid var(--side-nav-btn-border-color);
      border-radius: 0px 6px 6px 0px;
      height: 100%;
      width: 33px;
    }
  }
  .close-icon {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;

export const EnableZone = styled.div`
  display: grid;
  padding: 22px 0;
  /* border-bottom: 1px solid #72727399; */
  > div {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 13px;
    p {
      flex: 1;
      padding-left: 6px;
      color: var(--text-primary);
    }
  }
`;
export const CarType = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid #72727399;
  button {
    background: transparent;
    border: none;
    padding: 0;
  }
  > div {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 13px;
    color: var(--text-primary);
    p {
      flex: 1;
      padding-left: 6px;
    }
  }
  .filter-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left:15px;
  }
`;

export const DirectionSection = styled.div`
  padding: 0 0 16px;
  border-bottom: 1px solid #72727399;
  .direction-btn {
    background: var(--theme-text);
    color: #000;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    height: 28px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
    &.active {
      background: var(--selected-btn-bg);
      color: var(--theme-text);
      border: none;
    }
  }
  button {
    background: transparent;
    border: none;
  }
  .MuiSwitch-root .MuiSwitch-switchBase {
    padding: 1px;
  }
  .MuiSwitch-root .MuiSwitch-switchBase.Mui-checked {
    color: #00a692;
    .MuiSwitch-thumb,
    + .MuiSwitch-track {
      background-color: #00a692;
    }
  }

  .MuiSwitch-root .MuiSwitch-thumb {
    background-color: #92acb7;
    border: 3px solid #f2f6fa;
    box-shadow: none;
    width: 20px;
    height: 20px;
  }
  .MuiSwitch-track {
    background: #92acb7;
    opacity: 1;
    height: 8px;
    width: 92%;
  }
  > div {
    display: flex;
    align-items: center;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 13px;
    p {
      flex: 1;
      padding-left: 6px;
    }
    &.rotate-section {
      padding-top: 15px;
      align-items: center;
      gap: 11px;
      justify-content: center;
      img {
        cursor: pointer;
      }
    }
  }
`;

export const StyledWrapper = styled.div`
  position: relative;
  margin-bottom: 30px;

  .icon {
    position: absolute;
    z-index: 1;
    left: 12px;
    top: 8px;
  }
  .select {
    width: 100%;
    margin: 0;
    .MuiFormControl-root {
      width: 100%;
      margin: 0;
    }
    .MuiSelect-nativeInput {
      font-size: 13px;
    }
    .MuiInputBase-formControl {
      background: var(--input-background);
      border-radius: 6px;
      color: var(--text-primary);
    }
    .MuiSvgIcon-root {
      color: var(--text-secondary);
    }
    .MuiSelect-select {
      padding-top: 4px;
      padding-bottom: 4px;
      font-size: 13px;
      padding-left: 37px;
    }
  }
`;

export const CourseStyle = styled.div`
  display: flex;
  position: relative;
  margin-bottom: 30px;

  .icon {
    position: absolute;
    z-index: 1;
    left: 12px;
    top: 8px;
  }
  .select {
    width: 140px;
    margin: 0;
    .MuiFormControl-root {
      width: 100%;
      margin: 0;
    }
    .MuiSelect-nativeInput {
      font-size: 13px;
    }
    .MuiInputBase-formControl {
      background: var(--input-background);
      border-radius: 6px;
      color: var(--text-primary);
    }
    .MuiSvgIcon-root {
      color: var(--text-secondary);
    }
    .MuiSelect-select {
      padding-top: 4px;
      padding-bottom: 4px;
      font-size: 13px;
      padding-left: 37px;
    }
  }
`;

export const TextAreaStyled = styled.div`
  margin-top: 17px;
  margin-bottom: 12px;
  textarea {
    width: 100%;
    background: var(--input-background);
    border: 1px solid var() --border-color;
    border-radius: 6px;
    padding: 16px;
    font-size: 13px;
    line-height: 150.5%;
    color: var(--text-primary);
  }
`;
export const ToggleIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--theme-background);
  border-radius: 6px;
  .active {
    background-color: var(--theme-background) !important;
    border-radius: 6px !important;
    svg {
      g,
      path {
        opacity: 1;
        fill: var(--input-background);
      }
    }
  }
  /* .MuiToggleButtonGroup-root {
    border: 1px solid var(--theme-background);
    border-radius: 6px;
  }

  .Mui-selected {
    background-color: var(--theme-background) !important;
    border-radius: 6px !important;
    svg {
      g,
      path {
        opacity: 1;
        fill: var(--input-background);
      }
    }
  } */
`;

export const SaveActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  justify-content: center;
  button {
    font-size: 13px;
    line-height: 150.5%;
    height: 30px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    text-transform: capitalize;
    font-weight: normal;
    color: inherit;
    &.save-btn {
      background: var(--theme-background);
      color: #1d1d1d;
      border-color: var(--theme-background);
      width: 67px;
      border: none;
      color: var(--theme-text);
    }
    &.delete-btn {
      color: #fa3c30;
      background-color: transparent;
      border: 1px solid #fa3c30;
      width: 76px;
    }
    &.cancel-btn {
      background: transparent;
      border: 1px solid #67543e;
      border-radius: 30px;
    }
    &.reset-btn {
      background: transparent;
      border: 1px solid #fa3c30;
      border-radius: 30px;
    }
    &.active {
      background: #bc9b6a;
      color: #fff;
      border-color: transparent;
    }
    &.disabled {
      pointer-events: none;
      cursor: default;
      color: rgba(0, 0, 0, 0.26);
    }
  }
`;
export const Rule90 = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 13px;
  img {
    max-width: 100%;
  }
`;

export const HoleFlagWrapper = styled.div`
  display: flex;
  align-items: center;
  color: #d7d7d7;
  .hole-text {
    margin-left: 5px;
    color: var(--text-primary);
  }
  .select {
    margin-left: 14px;
    width: 59px;
    .MuiFormControl-root {
      width: 100%;
      margin: 0;
    }
    .MuiSelect-nativeInput {
      font-size: 13px;
    }
    .MuiInputBase-formControl {
      background: var(--input-background);
      border-radius: 6px;
      color: var(--text-primary);
    }
    .MuiSvgIcon-root {
      color: var(--text-secondary);
    }
    .MuiSelect-select {
      padding-top: 4px;
      padding-bottom: 4px;
      font-size: 13px;
      padding-left: 10px;
    }
  }
  .select .MuiFormControl-root {
    min-width: 66px;
  }

  img {
    margin-right: 9px;
  }
  span {
    font-size: 13px;
  }
`;
export const MuteSection = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  margin-bottom: 39px;
  justify-content: space-around;
  .active {
    background-color: var(--theme-background);
    border: 1px solid var(--theme-background);
  }
  .inactive {
    background-color: var(--theme-text);
    border: 1px solid var(--border-color);
  }
  .section-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border-radius: 5px;

    button {
      background-color: transparent;
      border: none;
      margin-top: 3px;
    }
  }
`;
